import { inject, Service } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { IRatingType } from 'app/core/models/order/rating';
import { catchError, Observable, throwError } from 'rxjs';
import { IData } from 'app/core/models/api/data';
import { environment } from '../../../../environments/environment';
import { IError } from 'app/core/models/error/error';

const urlGetRatingTypes = () => ['clinic', 'admin', 'order', 'rating-type'];

@Service()
export class RatingService {
    private readonly router = inject(Router);
    private readonly httpClient = inject(HttpClient);

    getRatingTypes(): Observable<IData<IRatingType[]>> {
        const url = this.router.createUrlTree(urlGetRatingTypes());

        const parsedUrl = `${environment.apiUrl}/${environment.apiVersion}${url}`;

        return this.httpClient.get<IData<IRatingType[]>>(parsedUrl, { responseType: 'json' }).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.error instanceof ErrorEvent) {
                    return throwError(() => `Error: ${error.error.message}`);
                }
                const errorApi: IError = error.error.error;
                return throwError(() => errorApi);
            }),
        );
    }
}
